export const localeConfig: configType = {
  EasyRedmineGatsby: {
    kr: {
      isAI: false,
      locale: `kr`,
      urlPrefix: `kr`,
      preferedContentLinkCulture: ``,
      isoCode: `ko-KR`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    jp: {
      isAI: false,
      locale: `jp`,
      urlPrefix: `jp`,
      preferedContentLinkCulture: ``,
      isoCode: `ja-JP`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    ru: {
      isAI: false,
      locale: `ru`,
      urlPrefix: `ru`,
      preferedContentLinkCulture: ``,
      isoCode: `ru-RU`,
      order: 3,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    br: {
      isAI: false,
      locale: `br`,
      urlPrefix: `br`,
      preferedContentLinkCulture: ``,
      isoCode: `pt-BR`,
      order: 4,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    es: {
      isAI: false,
      locale: `es`,
      urlPrefix: `es`,
      preferedContentLinkCulture: ``,
      isoCode: `es-ES`,
      order: 5,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    fr: {
      isAI: false,
      locale: `fr`,
      urlPrefix: `fr`,
      preferedContentLinkCulture: ``,
      isoCode: `fr-FR`,
      order: 6,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    de: {
      isAI: false,
      locale: `de`,
      urlPrefix: `de`,
      preferedContentLinkCulture: ``,
      isoCode: `de-DE`,
      order: 7,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    en: {
      isAI: false,
      locale: `en`,
      urlPrefix: ``,
      preferedContentLinkCulture: ``,
      isoCode: `en-GB`,
      order: 10,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    cs: {
      isAI: false,
      locale: `cs`,
      urlPrefix: `cs`,
      preferedContentLinkCulture: `cs-CZ`,
      isoCode: `cs-CZ`,
      order: 9,
      language: `Čeština`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    hu: {
      isAI: false,
      locale: `hu`,
      urlPrefix: `hu`,
      preferedContentLinkCulture: `hu-HU`,
      isoCode: `hu-HU`,
      order: 8,
      language: `Magyar`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    pl: {
      isAI: true,
      locale: `pl`,
      urlPrefix: `pl`,
      preferedContentLinkCulture: `pl-PL`,
      isoCode: `pl-PL`,
      order: 4,
      language: `Polski`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    it: {
      isAI: true,
      locale: `it`,
      urlPrefix: `it`,
      preferedContentLinkCulture: `it-IT`,
      isoCode: `it-IT`,
      language: `Italiano`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
    tr: {
      isAI: true,
      locale: `tr`,
      urlPrefix: `tr`,
      preferedContentLinkCulture: `tr-TR`,
      isoCode: `tr-TR`,
      order: 6,
      language: `Türkçe`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-readmine.puxdesign.net`,
        stage: `https://dev1.easysoftware.client.puxdesign.cz`,
        rdn: `https://rdn.easysoftware.client.puxdesign.cz`,
        production: `https://www.easy8.com`,
      },
      GTM: `GTM-NKJSRFS`,
    },
  },
  EasyProjectGatsby: {
    ru: {
      isAI: false,
      locale: `ru`,
      urlPrefix: `ru`,
      preferedContentLinkCulture: ``,
      isoCode: `ru-RU`,
      order: 3,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
    de: {
      isAI: false,
      locale: `de`,
      urlPrefix: `de`,
      preferedContentLinkCulture: ``,
      isoCode: `de-DE`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
    fr: {
      isAI: false,
      locale: `fr`,
      urlPrefix: `fr`,
      preferedContentLinkCulture: ``,
      isoCode: `fr-FR`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
    es: {
      isAI: false,
      locale: `es`,
      urlPrefix: `es`,
      preferedContentLinkCulture: ``,
      isoCode: `es-ES`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
    it: {
      isAI: false,
      locale: `it`,
      urlPrefix: `it`,
      preferedContentLinkCulture: ``,
      isoCode: `it-IT`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
    hu: {
      isAI: false,
      locale: `hu`,
      urlPrefix: ``,
      preferedContentLinkCulture: ``,
      isoCode: `hu-HU`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev3-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-3-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.hu`,
      },
      GTM: `GTM-NFPB4Z9`,
    },
    cs: {
      isAI: false,
      locale: `cs`,
      urlPrefix: ``,
      preferedContentLinkCulture: ``,
      isoCode: `cs-CZ`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev2-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-2-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.cz`,
      },
      GTM: `GTM-5SQG2G5`,
    },
    en: {
      isAI: false,
      locale: `en`,
      urlPrefix: ``,
      preferedContentLinkCulture: ``,
      isoCode: `en-GB`,
      domains: {
        development: `http://localhost:8000`,
        test: `http://easy-project.puxdesign.net`,
        stage: `http://dev1-ep.easysoftware.client.puxdesign.cz`,
        rdn: `http://rdn-1-ep.easysoftware.client.puxdesign.cz`,
        production: `https://www.easyproject.com`,
      },
      GTM: `GTM-K75449W`,
    },
  }
}

export const searchConfig: SearchConfig = {
  EasyRedmineGatsby: {
    apiKey: `AIzaSyDe18pSt4eqcHdG93c1Hjfo08ZqbcqMF5Y`,
    apiUrl: `https://www.googleapis.com/customsearch/v1/siterestrict`,
    localizedOptions: {
      en: {
        configId: `08ee585c-549c-4a65-bd53-6ed5130babb2`,
        knowledgeBaseConfigId: `490c608e-dff6-47d8-82cb-50c38454aa29`,
      },
      cs: {
        configId: `81e212ac-ac8f-4c0a-82b4-e83d3c3460fa`,
        knowledgeBaseConfigId: `d679a8d5-ab58-4c2f-b298-a407537dcd40`,
      },
      hu: {
        configId: `7a05694d-510d-4761-9720-aaeb2e75f87a`,
        knowledgeBaseConfigId: `3208e1be-3679-491a-95ed-cb63e70aecf6`,
      },
      ru: {
        configId: `f92f67ba-336d-4d3a-bba2-50bbf7261386`,
      },
      fr: {
        configId: `b7ab21fe-03c9-4720-995a-5251b6f9d6f7`,
      },
      kr: {
        configId: `319a1721-921d-4958-adb5-8b9182740ec2`,
      },
      br: {
        configId: `ba621fe1-9d98-4e58-8523-17781c5c451a`,
      },
      de: {
        configId: `064c7f96-aeba-43c6-a879-2a087699e02d`,
      },
      jp: {
        configId: `06b52079-93de-4e64-95c3-958c17bb9ca1`,
      },
      es: {
        configId: `65cecd2b-8f67-49f0-9766-49cf8ce2a9fc`,
      },
    },
  },
  EasyProjectGatsby: {
    apiKey: `AIzaSyDe18pSt4eqcHdG93c1Hjfo08ZqbcqMF5Y`,
    apiUrl: `https://www.googleapis.com/customsearch/v1/siterestrict`,
    localizedOptions: {
      en: {
        configId: `7cd2182a-9e90-4cfa-b1ba-28b5c6405ac8`,
        knowledgeBaseConfigId: `75156e0a-4561-4dc1-9fe4-1f92056f4502`,
      },
      cs: {
        configId: `81e212ac-ac8f-4c0a-82b4-e83d3c3460fa`,
        knowledgeBaseConfigId: `d679a8d5-ab58-4c2f-b298-a407537dcd40`,
      },
      hu: {
        configId: `7a05694d-510d-4761-9720-aaeb2e75f87a`,
        knowledgeBaseConfigId: `3208e1be-3679-491a-95ed-cb63e70aecf6`,
      },
      de: {
        configId: `475e32ed-659b-4c9f-83c4-e335c5626df1`,
      },
      es: {
        configId: `edb8355f-ffe1-4c2c-a612-b11eddbeee29`,
      },
      fr: {
        configId: `76317914-c4d9-444d-84e6-e9b97d7efc21`,
      },
      it: {
        configId: `2e83ac16-9273-41b8-ab7c-9c4f2e9651f2`,
      },
      ru: {
        configId: `9512e1d9-b8f7-4810-8641-2a57a97c4446`,
      },
    },
  },
}

export interface configType {
  [site: string]: siteConfigType
}
export interface siteConfigType {
  [lang: string]: langConfig
}

export interface langConfig {
  isAI: boolean
  locale: string
  urlPrefix: string
  isoCode: string
  order?: number
  language?: string
  preferedContentLinkCulture: string
  direction?: 'rtl' | 'ltr'
  domains: langDomain
  GTM: string
}

export interface langDomain {
  [domain: string]: string
}

interface SearchConfig {
  [project: string]: {
    apiKey: string
    apiUrl: string
    localizedOptions: SearchLocalizedOptions
  }
}

interface SearchLocalizedOptions {
  [locale: string]: {
    configId: string
    knowledgeBaseConfigId?: string
  }
}